<template>
  <social-sharing
    :url="url"
    :title="title"
    :description="content"
    :quote="quote"
    :networks="customNetworks"
    inline-template
  >
    <div>
      {{ $t("Поделиться в") }}
      <network network="facebook">
        <a href="#" :aria-label="$t('Поделиться в') + ' Facebook'"><i class="pro-icon-facebook1" aria-hidden="true"></i></a>
      </network>
      <network network="twitter">
        <a href="#" :aria-label="$t('Поделиться в') + ' Twitter'"><img src="@/assets/x-icon.png" class="mt-1" height="25" width="25" alt="x icon" aria-hidden="true"></a>
      </network>
      <a
        href="#"
        class="social-icon-link"
        :aria-label="$t('Поделиться в') + ' Instagram'"
        @click.prevent="$parent.shareInstagram()"
      >
        <i
          class="fab fa-square-instagram social-brand-icon"
          style="font-size: 24px; line-height: 1;"
          aria-hidden="true"
        ></i>
      </a>
      <network network="threads">
        <a href="#" class="social-icon-link" :aria-label="$t('Поделиться в') + ' Threads'">
          <i
            class="fab fa-square-threads social-brand-icon"
            style="font-size: 24px; line-height: 1;"
            aria-hidden="true"
          ></i>
        </a>
      </network>
    </div>
  </social-sharing>
</template>

<script>
export default {
  data() {
    return {
      customNetworks: {
        threads: {
          sharer: 'https://www.threads.net/intent/post?text=@title%0A@url',
          type: 'popup'
        }
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    quote: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: window.location.href
    }
  },
  methods: {
    async shareInstagram() {
      const shareText = [this.title, this.url].filter(Boolean).join(' ')
      let copied = false

      try {
        if (navigator.clipboard && shareText) {
          await navigator.clipboard.writeText(shareText)
          copied = true
        }
      } catch (e) {
        // ignore clipboard errors and still open Instagram
      }

      if (copied) {
        this.$noty.info(this.$t('Ссылка скопирована в буфер обмена'), {
          killer: true,
          timeout: 2000,
          layout: 'topRight'
        })
      } else {
        this.$noty.warning(this.$t('Не удалось скопировать ссылку'), {
          killer: true,
          timeout: 2000,
          layout: 'topRight'
        })
      }
    }
  }
}
</script>

<style scoped>
.social-icon-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
